import { render, staticRenderFns } from "./AdminManagePipelinesPage.vue?vue&type=template&id=fab000ca"
import script from "./AdminManagePipelinesPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminManagePipelinesPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports